import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  profile: {}
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, { payload }) => ({ ...state, token: payload.token }),
    setProfile: (state, { payload }) => ({ ...state, profile: payload.profile }),
    clearToken: () => ({ token: null, profile: { } })
  }
});

export const { setToken, clearToken, setProfile } = authSlice.actions;
export default authSlice.reducer;
